<!--变压器地图-->
<template>
	<div class="mapBody">
		<div id="transformerMap"></div>
	</div>
</template>
<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: [],
		data() {
			return {
				subtree: [],
				markerArr: [],
				map: undefined,
				clickTree: undefined,
				opts: {
					width: 250, // 信息窗口宽度
					height: 80, // 信息窗口高度
					title: "信息窗口", // 信息窗口标题
					enableMessage: true //设置允许信息窗发送短息
				},
				markList: [],
				PowerDistributionRoom: [], //配电房信息
				loadcapacity: 0,
				transformerList: [],

			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.initMap()
			this.inquireArchives()
		},
		destroyed() {},
		computed: {
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return backName => {
					return {
						'background-image': 'url(' + this.imgName(backName) + ')'
					}
				}
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			pointLists() {
				if (isempty(this.nowUnit)) {
					return []
				}
				return treeToList(this.nowUnit, 'next', function(e) {
					return e.next != undefined && e.next.length > 0
				}).reverse()
			},
			zoomLevel() {
				if (isempty(this.$store.cacheStore.getters.getWebConfig.ZoomLevel)) {
					return 12
				}
				return this.$store.cacheStore.getters.getWebConfig.ZoomLevel
			},
			centerPointList() {
				if (isempty(this.$store.cacheStore.getters.getWebConfig.CenterPoint)) {
					return []
				}
				return this.$store.cacheStore.getters.getWebConfig.CenterPoint.split(',')
			},
			nowArchivesTree() {
				//当前单位可查看台账设备树
				return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
			},
			powerRoom() {
				//获取配电房
				var list = treeToList(this.nowArchivesTree, 'next', item => {
					return item.hasOwnProperty("next")
				})
				return list.filter(item => {
					return item.devicetype == 2
				})
			},
		},
		watch: {
			nowUnit(nv, ov) {
				//单位切换了，刷新图符
				for (var i = 0, len = this.markList.length; i < len; i++) {
					var item = this.markList[i]
					item.remove()
				}
			},
			powerRoom(nv, ov) {
				this.inquireArchives()
			},
			PowerDistributionRoom(nv, ov) {
				this.initMap()
			}
		},
		methods: {
			//向地图添加标记点
			addMarker(data) {
				if (isempty(data.point)) {
					return
				}
				var point = this.dataToPoint(data.point)
				this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), 11);
				var marker = new BMap.Marker(point); //创建标注
				//提示框
				var label = new BMap.Label(data.name, {
					offset: new BMap.Size(20, -10)
				});
				label.setStyle({
					borderColor: "#808080",
					color: "#333",
					cursor: "pointer"
				});
				marker.setLabel(label);
				//详细信息框
				// var html = "<div style='height: 60px;width:280px'>" +
				// 	"<div class='title'><p>" + data.name + "</p></div>" +
				// 	"<div><span>变压器数量：" + data.transformerCount + " </span></div>" +
				// 	"<div><span>总容量：" + data.capacity + " </span></div>" +
				// 	"</div>";
				var html = "<div class='bmapInfo'>" +
					"<div class='bmapInfo_title'><p>" + data.name + "</p></div>" +
					"<div class='bmapInfo_cont'><p>变压器数量：" + data.transformerCount + " </p></div></div>";
				var infoWindow = new BMap.InfoWindow(html, {
					offset: {
						width: 0,
						height: -20
					}
				});
				//往上移动20px
				marker.addEventListener("mouseover", () => {
					this.map.openInfoWindow(infoWindow, point);
				});
				this.map.addOverlay(marker);
				this.markList.push(marker)
			},
			//把data转换成 百度地图point
			dataToPoint(data) {
				if (isempty(data)) {
					return {}
				}
				var lnglatArray = data.split(',') //切成 数组
				if (lnglatArray.length != 2) {
					return {}
				}
				var lng = parseFloat(lnglatArray[0])
				var lat = parseFloat(lnglatArray[1])
				return new BMap.Point(lng, lat);
			},
			initMap() {
				if (typeof(BMap) == 'undefined') {
					return
				}
				this.map = new BMap.Map("transformerMap", {
					mapType: BMAP_HYBRID_MAP,
					enableMapClick: false
				})
				for (var i = 0, len = this.PowerDistributionRoom.length; i < len; i++) {
					var tempDate = {
						point: '', //经纬度
						name: '', //配电房名称
						path: '', //配电房地址
						transformerCount: '', //变压器数量
						capacity: '', //变压器容量
					}
					tempDate.name = this.PowerDistributionRoom[i].name
					this.transformerList = []
					this.recursiveTfr([this.PowerDistributionRoom[i]])
					this.getArchivesInfo(this.transformerList)
					tempDate.capacity = this.loadcapacity
					this.PowerDistributionRoom[i].next.forEach(item => {
						if (item.propertyCode == 'Path') {
							tempDate.path = item.value
						} else if (item.propertyCode == 'Coordinate') {
							tempDate.point = item.value
						} else if (item.propertyCode == 'TransformerCount') {
							tempDate.transformerCount = item.value
						}
						this.addMarker(tempDate)
					})
				}
				this.map.addControl(new BMap.MapTypeControl({
					mapTypes: [
						BMAP_HYBRID_MAP,
						BMAP_NORMAL_MAP
					]
				}));
				this.map.enableScrollWheelZoom(true);
			},
			inquireArchives() {
				//查询配电房台账信息
				var nos = ''
				if (isempty(this.powerRoom)) {
					return
				}
				this.powerRoom.forEach(item => {
					nos += item.no + ','
				})
				var _this = this
				this.PowerDistributionRoom = []
				this.$api.archivesApi.getArchivesInfoByVirtualGroupNos(nos, respon => {
					Object.keys(respon).forEach(function(key) {
						if (!isempty(respon[key])) {
							_this.PowerDistributionRoom.push(respon[key])
						}
					});
				})
			},
			getArchivesInfo(archivesTree) {
				this.loadcapacity = 0
				if (!isempty(archivesTree)) {
					var ids = ''
					archivesTree.forEach(e => {
						ids += e.archivesId + ','
					})
					if (isempty(ids)) {
						return
					}
					this.$api.archivesApi.getArchivesInfoByIds(ids, respon => {
						if (!isempty(respon)) {
							var temp1 = 0
							respon.forEach(e => {
								e.next.forEach(i => {
									if (i.propertyCode == 'Capacity') {
										if (!isempty(i.value)) {
											temp1 += parseFloat(i.value)
										}
									} else if (i.propertyCode == 'Power') {}
								})
							})
							this.loadcapacity = temp1 //额定容量
						}
					})
				}
			},
			recursiveTfr(item) {
				item.forEach(i => {
					if (!isempty(i.archivesTypeCode) || i.archivesTypeCode == 'Transformer') {
						this.transformerList.push(i)
					} else {
						if (!isempty(i.next)) {
							this.recursiveTfr(i.next)
						}
					}
				})
			}
		}
	}
</script>
<style scoped>
	.mapBody {
		width: 97%;
		height: 95%;
		background-repeat: no-repeat;
		background-size: 100%;
		margin-top: .1rem;
	}

	#transformerMap {
		width: 100%;
		height: 100%;
	}
</style>
